import type { AssetRests } from '@/entities/account';
import type { ExchangeAssetsRequestDto } from '../api';

export const EXCHANGE_SECTION_TYPES = {
  FROM: 'from',
  TO: 'to',
} as const;

export type ExchangeInputSectionType =
  (typeof EXCHANGE_SECTION_TYPES)[keyof typeof EXCHANGE_SECTION_TYPES];

export type ExchangeAsset = Pick<
  AssetRests,
  'code' | 'name' | 'baseAvailable' | 'precision' | 'group'
> & {
  icon: string;
  available?: number;
  deltaPercent: number;
  price: number;
};

export type ExchangeAssetSelectItem = ExchangeAsset & {
  value: string;
};

export type ExchangeQuickSelectItem = Pick<ExchangeAsset, 'code' | 'icon'>;

export type ExchangeAmountSource = 'pay' | 'receive' | null;

export const EXCHANGE_RESULT_VARIANTS = {
  PAGE: 'page',
  SECTION: 'section',
} as const;

export type ExchangeResultVariant =
  (typeof EXCHANGE_RESULT_VARIANTS)[keyof typeof EXCHANGE_RESULT_VARIANTS];

export type ExchangeConfirmationArgs = {
  title: string;
  resultVariant?: ExchangeResultVariant;
  amountToPay: number;
  amountToReceive: number;
  assetCodeToPay: string;
  assetCodeToReceive: string;
  conversionRate: {
    leftPart: string;
    rightPart: string;
  };
  formData: ExchangeAssetsRequestDto;
  onSuccess?: () => void;
};
